import {Autocomplete, Box, createFilterOptions, TextField} from "@mui/material";
import React from "react";
import {AutocompleteProps} from "../../components/SearchBox";
import {MachineApiGet, useGetMachineQuery} from "./machine_api";
import {OperationApiGet} from "../operation/operation_api";
import AvatarImage from "../storage/AvatarImage";


export default ({setFieldValue, value, name, error, label}: AutocompleteProps<MachineApiGet>) => {

    const {data} = useGetMachineQuery({active: true});

    return <Autocomplete
        id={name}
        options={data || []}
        sx={{minWidth: "150px"}}
        value={value}
        onChange={(e, v: MachineApiGet | null) => {
            setFieldValue(name, v)
        }}
        getOptionKey={o => o.id}
        getOptionLabel={(option: MachineApiGet) => {
            return option.Name;
        }}
        filterOptions={createFilterOptions({
            stringify: (option) => option.Name + " " + option.Code,
        })}
        renderOption={(props, option: MachineApiGet) => {
            const {key, ...rest} = props
            return <Box key={key} component="li" sx={{'& > .MuiAvatar-root': {mr: 1}}} {...rest}>
                <AvatarImage image_url={option.image_url} bucket={"machines"}/> {option.Code} {option.Name}
            </Box>
        }}
        renderInput={(params) => (
            <TextField
                {...params}
                label={label}
                error={Boolean(error)}
                helperText={error}
            />
        )}
    />

}
